var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconEducation = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-297 -253.425)" },
                React.createElement("path", { d: "M303.2,260.9l4,1c-1.3,2.6-0.2,5.9,2.4,7.2c2.6,1.3,5.9,0.2,7.2-2.4\n\t\tc0.4-0.7,0.6-1.6,0.6-2.4c0-0.8-0.2-1.6-0.6-2.4l4-1c0.4-0.1,0.6-0.4,0.6-0.8c0-0.3-0.3-0.5-0.6-0.6l-8-1.9c-0.5-0.1-1.1-0.1-1.7,0\n\t\tl-8,1.9c-0.4,0.1-0.6,0.4-0.6,0.8C302.6,260.6,302.9,260.8,303.2,260.9z" }),
                React.createElement("g", { transform: "translate(298.11 270.983)" },
                    React.createElement("path", { d: "M24.8,8.3c0-2.9-2.4-5.3-5.3-5.3H8.9C6,3,3.6,5.4,3.6,8.3" })),
                React.createElement("path", { strokeWidth: "1", d: "M303.8,265.2c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3l0,0\n\t\tC303.2,263.8,303.8,264.4,303.8,265.2z" }),
                React.createElement("line", { strokeWidth: "1", x1: "302.3", y1: "261.2", x2: "302.3", y2: "263.6" })))));
});
export default IconEducation;
//# sourceMappingURL=IconEducation.js.map